import React, { useState } from 'react';
import logo from '../assets/yii_page-0002.png';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);



  const LOGIN_URL = 'https://www.yam-ii.com/yam_api/admin_login.php';


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });
      
      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();

      if (data.status === 'success') {
        // تخزين مفتاح الجلسة
        sessionStorage.setItem('isAdmin', 'true'); 
        alert("تم تسجيل الدخول بنجاح ✅");
        window.location.replace('/admin-dashboard'); 
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('تعذر الاتصال بالسيرفر. يرجى التحقق من اتصال الإنترنت أو المحاولة لاحقاً');;
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleLogin} autoComplete="off">
        <img src={logo} alt="Logo" style={{ width: '80px', marginBottom: '10px' }} />
        <h2 style={styles.title}>دخول الإدارة</h2>
        
        {error && <div style={styles.errorBox}>{error}</div>}
        
        <input 
          type="text" 
          placeholder="اسم المستخدم" 
          style={styles.input} 
          required
          value={credentials.username}
          onChange={e => setCredentials({...credentials, username: e.target.value})} 
        />
        
        <input 
          type="password" 
          placeholder="كلمة المرور" 
          style={styles.input} 
          required
          value={credentials.password}
          onChange={e => setCredentials({...credentials, password: e.target.value})} 
        />
        
        <button type="submit" style={styles.btn} disabled={loading}>
          {loading ? 'جاري التحقق...' : 'دخول'}
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: { display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', background:'#1a3a5a', direction: 'rtl' },
  form: { background:'#fff', padding:'40px', borderRadius:'15px', width:'350px', textAlign:'center' },
  title: { color: '#1a3a5a', marginBottom: '20px' },
  input: { width:'100%', padding:'12px', marginBottom:'15px', borderRadius:'8px', border:'1px solid #ddd', boxSizing:'border-box' },
  btn: { width:'100%', padding:'12px', background:'#d4af37', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight: 'bold' },
  errorBox: { background: '#fee', color: '#e74c3c', padding: '10px', borderRadius: '5px', marginBottom: '15px', fontSize: '0.8rem' }
};

export default AdminLogin;